export default __webpack_public_path__ + "static/montserrat-v15-latin-900-efe8eb9a74a1856b29398cd61d3c458f.ttf";